import apolloUtil from '@/service/ApolloUtil'
import { InMemoryCache } from 'apollo-cache-inmemory'

import pileMovementsListQuery from '@/service/pileMovement/PileMovementsListQuery.gql'
import pileMovementDeletionPreviewQuery from '@/service/pileMovement/PileMovementDeletionPreview.gql'
import downloadPileMovementAttachmentQuery from '@/service/pileMovement/DownloadPileMovementAttachmentQuery.gql'
import savePileMovementAttachmentMutation from '@/service/pileMovement/SavePileMovementAttachmentMutation.gql'
import deletePileMovementAttachmentMutation from '@/service/pileMovement/DeletePileMovementAttachmentMutation.gql'

class PileMovementService {

  search(params) {
    return apolloUtil.query(pileMovementsListQuery, params)
      .then((response) => response?.data?.pileMovementsList)
  }

  deletionPreview(pileMovementId) {
    const variables = { pileMovementId }
    return apolloUtil.query(pileMovementDeletionPreviewQuery, variables)
      .then(response => {
        // Cached or repeated entities must not fill fields missing from this response.
        const responseCache = new InMemoryCache({ dataIdFromObject: () => null })
        responseCache.writeQuery({ query: pileMovementDeletionPreviewQuery, variables, data: response?.data })
        if (!responseCache.diff({ query: pileMovementDeletionPreviewQuery, variables }).complete) {
          throw new Error('Incomplete pile movement deletion preview')
        }

        const preview = response?.data?.pileMovementDeletionPreview
        const selectedLoad = preview?.selectedLoad
        const linkedUnloads = preview?.linkedUnloads

        if (!selectedLoad || selectedLoad.id !== pileMovementId || selectedLoad.type !== 'LOAD'
          || !Array.isArray(selectedLoad.unloadOperations)
          || !Array.isArray(linkedUnloads)
          || linkedUnloads.some(link => link?.movement?.id == null || link.movement.type !== 'UNLOAD'
            || !Array.isArray(link.movement.unloadOperations))) {
          throw new Error('Invalid pile movement deletion preview')
        }

        if (linkedUnloads.length === 0
          && (!['number', 'string'].includes(typeof selectedLoad.unload)
            || String(selectedLoad.unload).trim() === '' || Number(selectedLoad.unload) !== 0
            || selectedLoad.movedFrom !== null)) {
          throw new Error('Incomplete pile movement deletion preview')
        }
        return preview
      })
  }

  downloadAttachment(params) {
    return apolloUtil.query(downloadPileMovementAttachmentQuery, params)
      .then((response) => response?.data?.downloadPileMovementAttachment)
  }

  saveAttachment(params) {
    return apolloUtil.mutate(savePileMovementAttachmentMutation, params)
  }

  deleteAttachment(params) {
    return apolloUtil.mutate(deletePileMovementAttachmentMutation, params)
  }

}

export default new PileMovementService()
